import { createBrowserRouter, Navigate } from 'react-router-dom';
import SignInPage from '../pages/auth/sign-in.tsx';
import RegisterPage from '../pages/auth/register.tsx';
import VerifyEmailPage from '../pages/auth/verify-email.tsx';
import ResendVerificationPage from '../pages/auth/resend-verification.tsx';
import ForgotPasswordPage from '../pages/auth/forgot-password.tsx';
import ResetPasswordPage from '../pages/auth/reset-password.tsx';
import NotFoundPage from '../pages/not-found.tsx';
import AuthProtectedRoute from './auth-protected-route.tsx';
import Providers from '../providers.tsx';
import UsersPage from '../pages/user/list.tsx';
import AddUserPage from '../pages/user/add.tsx';
import EditUserPage from '../pages/user/edit.tsx';
import StatsPage from '../pages/user/stats.tsx';
import CoursesPage from '../pages/course/list.tsx';
import CreateCoursePage from '../pages/course/create.tsx';
import CourseAnalysisPage from '../pages/course/analysis.tsx';
import CourseEditPage from '../pages/course/edit.tsx';
import OrganizationStatsPage from '../pages/organization/stats.tsx';
import NotificationsPage from '../pages/notifications/notifications.tsx';
import SettingsPage from '../pages/settings/settings.tsx';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Providers />,
    children: [
      {
        path: '/',
        element: <Navigate to="/sign-in" replace />,
      },
      {
        path: '/sign-in',
        element: <SignInPage />,
      },
      {
        path: '/register',
        element: <RegisterPage />,
      },
      {
        path: '/verify-email',
        element: <VerifyEmailPage />,
      },
      {
        path: '/resend-verification',
        element: <ResendVerificationPage />,
      },
      {
        path: '/forgot-password',
        element: <ForgotPasswordPage />,
      },
      {
        path: '/reset-password',
        element: <ResetPasswordPage />,
      },
      {
        path: '/',
        element: <AuthProtectedRoute />,
        children: [
          {
            path: '/users',
            element: <UsersPage />,
          },
          {
            path: '/users/add',
            element: <AddUserPage />,
          },
          {
            path: '/users/:id/edit',
            element: <EditUserPage />,
          },
          {
            path: '/users/:id/stats',
            element: <StatsPage />,
          },
          {
            path: '/courses',
            element: <CoursesPage />,
          },
          {
            path: '/courses/new',
            element: <CreateCoursePage />,
          },
          {
            path: '/analysis/:id',
            element: <CourseAnalysisPage />,
          },
          {
            path: '/edit/:id',
            element: <CourseEditPage />,
          },
          {
            path: '/organization',
            element: <OrganizationStatsPage />,
          },
          {
            path: '/notifications',
            element: <NotificationsPage />,
          },
          {
            path: '/settings',
            element: <SettingsPage />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);

export default router;
